<ng-template #nameCell let-call>
  <span [class.soft-deleted]="call.markedToBeDeletedAt !== null" [matTooltip]="softDeletionNote(call)">{{ call.name }}</span>
</ng-template>

<ng-template #callUsersCell let-call>
  @if (call.users.length > 0) {
    <div class="user-avatar-list">
      @for (user of call.users; track user.userId) {
        <app-avatar [input]="user.firstName + ' ' + user.lastName" size="small" [matTooltip]="user.firstName + ' ' + user.lastName"></app-avatar>
      }
    </div>
  } @else {
    -
  }
</ng-template>

<ng-template #softDeletionCell let-call>
  @let deletion = softDeletionOf(call);
  <span class="deletion-date" [class.happened]="deletion.hasHappened" [matTooltip]="deletion.note">{{ deletion.label }}</span>
</ng-template>

<ng-template #hardDeletionCell let-call>
  @let deletion = hardDeletionOf(call);
  <span class="deletion-date" [class.happened]="deletion.hasHappened" [matTooltip]="deletion.note">{{ deletion.label }}</span>
</ng-template>

<div class="page-container">
  <app-toolbar [title]="'COMMON.CALLS' | translate"></app-toolbar>

  <div class="page">
    <div class="panel">
      <app-table
        [source]="source"
        [columns]="columns"
        [rowId]="rowId"
        [rowActions]="rowActions"
        [pageSize]="defaultPageSize"
        [defaultSort]="defaultSort"
        [selectable]="false"
        [syncUrl]="true"
        tableId="admin-calls"
        label="COMMON.CALLS"
        rowNoun="ADMIN.CALLS.CALL"
        rowNounPlural="ADMIN.CALLS.CALLS"
        csvFilename="meetings"
        (rowActionTriggered)="handleRowAction($event)"
      />
    </div>
  </div>
</div>
